import { axios, axiosPisCofins } from "../../constants/axiosConfig";
import { axiosTermoUso } from "../../constants/axiosTermoUso";
import { setSessaoToken } from "../../helpers/Token";
import { keycloakClient } from "../../keycloak/client";
const isDevelopment = () => process.env.NODE_ENV === "development";

export function signin(data) {
  return (dispatch) => {
    dispatch({
      type: "SIGNIN_REQUEST",
    });

    axiosPisCofins
      .post(`/login`, data)
      .then(async (response) => {
        const {
          CloudOci,
          Token,
          Login,
          IdLogin,
          IsAdmin,
          PlanoMaster,
          PlanoTeste,
          PlanoRecuperadorLimitado,
          LogoEmpresa,
          Status,
          CodigoAcessoPlanilha,
          OcultarPlanilhaCalculo,
          NomeDoUsuario,
          ClienteRazaoSocial,
          PlanoProfissionalLiberal,
          PlanoMeuPrimeiroClienteCompleto,
        } = response.data.Retorno;

        if (response.data?.StatusCode === 200 && Token) {
          localStorage.setItem("teste", JSON.stringify(response.data.Retorno));

          sessionStorage.setItem("CloudOci", CloudOci);
          sessionStorage.setItem("eRecuperadorJwt", Token);
          sessionStorage.setItem("Login", window.btoa(Login));
          sessionStorage.setItem("IdLogin", window.btoa(IdLogin || 0));
          sessionStorage.setItem("Status", Status);
          sessionStorage.setItem("nome", NomeDoUsuario);
          sessionStorage.setItem("email", Login);

          setSessaoToken({
            planoMaster: PlanoMaster,
            planoTeste: PlanoTeste,
            planoRecuperadorLimitado: PlanoRecuperadorLimitado,
            codigoAcessoPlanilha: CodigoAcessoPlanilha,
            ocultarPlanilhaCalculo: OcultarPlanilhaCalculo,
            clienteRazaoSocial: ClienteRazaoSocial,
            planoProfissionalLiberal: PlanoProfissionalLiberal,
            planoMeuPrimeiroClienteCompleto: PlanoMeuPrimeiroClienteCompleto,
          });
          if (IsAdmin) sessionStorage.setItem("IsAdmin", IsAdmin);
          if (LogoEmpresa) sessionStorage.setItem("LogoEmpresa", LogoEmpresa);

          if (await isContratoAceito()) {
            window.location = "/bemvindo";
          } else {
            window.location = "/contrato";
          }

          dispatch({
            type: "SIGNIN_SUCCESS",
          });
        } else {
          // Caso n�o esteja logado, redireciona para o Conta ou para o Login
          let contaUrl = process.env.REACT_APP_CONTA_URL;

          if (response.data?.StatusCode === 401 && response.data.Mensagem) {
            contaUrl =
              contaUrl + `/Home/Conta?mensagem=${response.data.Mensagem}`;
          }

          window.location = isDevelopment() ? "/login" : contaUrl;
        }
      })
      .catch(() => {
        dispatch({ type: "SIGNIN_FAILURE" });
      });
  };
}

export const logoutKeycloak = async () => {
  try {
    await keycloakClient.logout({ redirectUri: process.env.REACT_APP_CONTA_URL });
    localStorage.clear();
    sessionStorage.clear();
    window.location = process.env.REACT_APP_CONTA_URL;
  } catch (e) {
    console.log(e);
  }  
};

export function logout() {
  return async (dispatch) => {
    dispatch({
      type: "LOGOUT_REQUEST",
    });
    await logoutKeycloak();
    await axiosPisCofins.post("logout", {});
    sessionStorage.clear();
    dispatch({
      type: "LOGOUT_SUCCESS",
    });
    window.location = "/";
  };
}

export const logoutContaUnica = async () => {
  localStorage.clear();
  await logoutKeycloak();
  axios
    .get(`${process.env.REACT_APP_CONTA_API_URL}/logout`)
    .then((response) => {
      sessionStorage.clear();
      window.location = process.env.REACT_APP_CONTA_URL;
    })
    .catch(() => {
      sessionStorage.clear();
      window.location = process.env.REACT_APP_CONTA_URL;
    });
};

export const aceitarContrato = async () => {
  try {
    const { status, data } = await axiosTermoUso.post(`SalvarContratoAceito/5`);
    if (status === 200 && data.sucesso) {
      localStorage.setItem("eRecuperadorAceito", true);
      return {
        status: true,
        message: "Termo de uso aceito com sucesso!!!",
      };
    }
  } catch {
    localStorage.setItem("eRecuperadorAceito", false);
    return {
      status: false,
      message: "Aconteceu alguma falha ao aceitar o Termo de uso",
    };
  }
};

export const getTermoUso = async () => {
  var response = await axiosTermoUso.get(`ObtemTermoUso/5`, {
    responseType: "blob",
  });
  if (response.data) {
    var blob = new Blob([response.data], { type: "application/pdf" });
    var url = window.URL.createObjectURL(blob);
    return url;
  }

  return "";
};

export const isContratoAceito = async () => {
  try {
    const { status, data } = await axiosTermoUso.post(
      `VerificaContratoAceito/5`
    );
    const contratoAceito = status === 200 && data.sucesso;
    localStorage.setItem("eRecuperadorAceito", contratoAceito);
    return contratoAceito;
  } catch (error) {
    return false;
  }
};
